<div class="breadcrumbs">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <a (click)="onClick(i)" class="link">{{breadcrumb.label}} /</a>
  </ng-container>
</div>
